module.exports = __webpack_public_path__ + "static/media/icon-back-white.b1abc3b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-back-white.svg
// module id = 1453
// module chunks = 0